import { __rest, __assign } from '../../../../../_virtual/_tslib.js';
import React, { Suspense } from 'react';

var CommentSection = React.lazy(function () { return import('./CommentSection.js'); });
var LazyLoadedCommentSection = function (_a) {
    var show = _a.show, commentSectionStartRef = _a.commentSectionStartRef, props = __rest(_a, ["show", "commentSectionStartRef"]);
    var componentStart = React.createElement("div", { ref: commentSectionStartRef });
    if (!show)
        return componentStart;
    return (React.createElement(React.Fragment, null,
        componentStart,
        React.createElement(Suspense, { fallback: null },
            React.createElement(CommentSection, __assign({}, props)))));
};

export { LazyLoadedCommentSection as default };
//# sourceMappingURL=LazyLoadedCommentSection.js.map
